export default __webpack_public_path__ + "assets/icons/billing-invoicing.cc21d45b.svg";